/**
 * GrainDistillateType
 */
export type GrainDistillateType = 'ALT_WHISKY' | 'CEREAL_WHISKY' | 'OTHER';

export const GrainDistillateType = {
  AltWhisky: 'ALT_WHISKY' as GrainDistillateType,
  CerealWhisky: 'CEREAL_WHISKY' as GrainDistillateType,
  Other: 'OTHER' as GrainDistillateType,
};
